import './CopyLink.css';
import { NotificationManager} from 'react-notifications'

const CopyLink = ({linkHost, linkParticipant, role}) => {
    const link = 'https://frontend-ta-wiyata.netlify.app/precall/';
    linkHost = link + linkHost
    linkParticipant = link+linkParticipant
    const handleCopy = (role) =>{
        NotificationManager.success('Link for '+ role+' has been copied', 'Success');
    }
	return (
		<div id="share-link-wrapper">
            {role === 'HOST' ?
            <div class="form-link">
                <div class="form-link-label">Link precall to join as host:</div>
                <div class="share-link-input__wrapper">
                    <input
                        class="wiyata-text-input"
                        type="text" 
                        id="link--host"
                        value={linkHost}
                        disabled
                    />
                    <button class="wiyata-btn"
                        onClick={() =>{navigator.clipboard.writeText(linkHost);handleCopy("host")}}
                        >
                        Copy
                    </button>
                </div>
            </div>
            : null}
       
            <div class="form-link">
                <div class="form-link-label">Link precall to join as student:</div>
                <div class="share-link-input__wrapper">
                    <input
                        class="wiyata-text-input"
                        type="text" 
                        id="link--participant"
                        value={linkParticipant}
                        disabled
                    />
                    <button class="wiyata-btn"
                        onClick={() =>{navigator.clipboard.writeText(linkParticipant);handleCopy("student")}}
                        >
                        Copy
                    </button>
                </div>
            </div>
        </div>
	);
}
 
export default CopyLink;
